var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"add-success"}},[_c('div',{staticClass:"box",attrs:{"id":"container"}},[_vm._v(_vm._s(_vm.$ml.get('add_success.success')))])])}
var staticRenderFns = []

export { render, staticRenderFns }